import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=39a7cb2c&scoped=true&"
import script from "@/views/Subjects/Notes.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/Notes.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/notes.scss?vue&type=style&index=0&id=39a7cb2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7cb2c",
  null
  
)

export default component.exports